export default __webpack_public_path__ + "static/human-c937e71437f9196af5de0040c36e328c.svg";